import React from 'react';
import Icon from './Icon';
import Reveal from './Reveal';
import './Investment.css';

export default function Investment() {
  return (
    <section className="invest section" id="invest">
      <div className="container invest__inner">
        <Reveal className="invest__copy">
          <span className="eyebrow eyebrow--light">Open for Investment &amp; Partnership</span>
          <h2>Build the future of Ghanaian logistics with us</h2>
          <p>
            BikesDrop is actively welcoming investors and partners who want to back a platform solving
            real logistics and e-commerce problems for customers, riders and merchants across Ghana.
            Whether it&rsquo;s funding, distribution, technology or strategic partnership, we&rsquo;d
            like to talk.
          </p>

          <div className="invest__points">
            <div>
              <strong>
                <Icon name="creditCard" size={18} />
              </strong>
              <span>Investment opportunities across product, fleet and market expansion</span>
            </div>
            <div>
              <strong>
                <Icon name="users" size={18} />
              </strong>
              <span>Strategic partnerships with pharmacies, retailers, campuses &amp; businesses</span>
            </div>
            <div>
              <strong>
                <Icon name="trendingUp" size={18} />
              </strong>
              <span>A founding team ready to move fast with the right partners on board</span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={120} className="invest__card">
          <span className="invest__card-label">Talk to our Founder &amp; CEO</span>
          <h3>Isaac Tetteh</h3>
          <p className="invest__card-role">Founder, CEO &amp; Developer, BikesDrop</p>

          <div className="invest__contact">
            <a href="tel:+233559588317" className="invest__contact-row">
              <span className="invest__contact-icon">
                <Icon name="phone" size={17} />
              </span>
              <div>
                <span>Phone</span>
                <strong>+233 55 958 8317</strong>
              </div>
            </a>
            <a href="mailto:isaac7tetteh@gmail.com" className="invest__contact-row">
              <span className="invest__contact-icon">
                <Icon name="mail" size={17} />
              </span>
              <div>
                <span>Email</span>
                <strong>isaac7tetteh@gmail.com</strong>
              </div>
            </a>
          </div>

          <a href="mailto:isaac7tetteh@gmail.com?subject=BikesDrop%20Investment%20%2F%20Partnership%20Inquiry" className="btn btn--teal btn--block">
            Start a Conversation
          </a>
        </Reveal>
      </div>
    </section>
  );
}
